module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av123-b7556abb0b58c951fed5273c2c0d2fa7.jpg";